
import { useEffect, useState } from 'react';
import { supabase, getWebsiteId } from '../../lib/supabase';

export default function MaintenancePage() {
  const [siteName, setSiteName] = useState('');
  const [logoUrl, setLogoUrl] = useState('');

  useEffect(() => {
    fetchSiteInfo();
  }, []);

  const fetchSiteInfo = async () => {
    try {
      const websiteId = await getWebsiteId();
      const { data } = await supabase
        .from('theme_settings')
        .select('site_title, logo_url')
        .eq('website_id', websiteId)
        .maybeSingle();
      
      if (data) {
        setSiteName(data.site_title || '');
        setLogoUrl(data.logo_url || '');
      }
    } catch (error) {
      console.error('Site bilgisi yüklenirken hata:', error);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 flex items-center justify-center p-6">
      <div className="max-w-lg w-full text-center">
        {/* Logo */}
        {logoUrl && (
          <div className="mb-8">
            <img 
              src={logoUrl} 
              alt={siteName || 'Logo'} 
              className="h-16 mx-auto object-contain"
            />
          </div>
        )}

        {/* İkon */}
        <div className="w-24 h-24 bg-gradient-to-br from-teal-400 to-teal-600 rounded-full flex items-center justify-center mx-auto mb-8 shadow-lg">
          <i className="ri-tools-line text-5xl text-white"></i>
        </div>

        {/* Başlık */}
        <h1 className="text-3xl font-bold text-gray-900 mb-4">
          Sitemiz Şu Anda Bakımda
        </h1>

        {/* Açıklama */}
        <p className="text-gray-600 mb-8 leading-relaxed">
          Sizlere daha iyi hizmet verebilmek için sitemizde bazı güncellemeler yapıyoruz. 
          Kısa süre içinde tekrar hizmetinizde olacağız.
        </p>

        {/* Animasyonlu Yükleme */}
        <div className="flex items-center justify-center gap-2 mb-8">
          <div className="w-3 h-3 bg-teal-500 rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></div>
          <div className="w-3 h-3 bg-teal-500 rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></div>
          <div className="w-3 h-3 bg-teal-500 rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></div>
        </div>

        {/* Bilgi Kartı */}
        <div className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100">
          <div className="flex items-center justify-center gap-3 text-gray-500">
            <i className="ri-time-line text-xl text-teal-500"></i>
            <span>Anlayışınız için teşekkür ederiz</span>
          </div>
        </div>

        {/* Site Adı */}
        {siteName && (
          <p className="mt-8 text-sm text-gray-400">
            {siteName}
          </p>
        )}
      </div>
    </div>
  );
}
